<script setup>
import { nextTick, onMounted, ref } from "vue";

defineProps([
	'modelValue',
	'maxlength'
]);

const emit = defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});


const emitValue = (value) => {

  // Remove non-ASCII characters
  let sanitizedValue = (!/^[ -~]+$/.test(value)) ? value.replaceAll(/[^ -~]+/g, '') : value;

  if (value !== sanitizedValue){
    emit('update:modelValue', '-');
  }

  nextTick(() => {
    emit('update:modelValue', sanitizedValue);
  });

};


</script>

<template>
    <div class="form-group">

    <textarea class="form-control w-100 textarea"
        :value="modelValue"
        :maxlength="maxlength || 500"
        @input="emitValue($event.target.value)"
        ref="input">
		</textarea>

	</div>
</template>
